import { CcLibrarySetModule } from "server/models"
import { POST } from "client/store/utils"

export const AddCcLibrarySetModule = (data: CcLibrarySetModule) => (
    POST(
        "/ccLibrarySetModule/add",
        JSON.stringify(data),
    ).then((res) => {
        const newModule = res as CcLibrarySetModule
        return newModule.setId ? newModule : null
    })
)

export const DeleteCcLibrarySetModule = (data: CcLibrarySetModule) => (
    POST(
        "/ccLibrarySetModule/delete",
        JSON.stringify(data),
    ).then((removedRows: number) => removedRows)
)
